import { useSearchParams } from "react-router-dom";
import Breadcrumb from "../../SharedComponents/components/Breadcrumb/Breadcrumb";
import { useGetIdParam } from "../../SharedComponents/hooks/useGetIdParam";
import BuyerLayout from "../components/Layout";
import { useParseQueryParams } from "../../SharedComponents/hooks/useParseQueryParams";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getPartOffer } from "../reduxStore/entities/partOffers";
import PartOfferCarInfoDiv from "../components/PartOfferComponents/PartOfferCarInfoDiv";
import PartOfferPartRequestInfoDiv from "../components/PartOfferComponents/PartOfferPartRequestInfoDiv";
import PartOfferBody from "../components/PartOfferComponents/PartOfferBody";
import PartOfferSellerInfoSection from "../components/PartOfferComponents/ParOfferSellerInfoSection";
import PartOfferFooterSection from "../components/PartOfferComponents/PartOfferFooterSection";
import MessageDrawer from "../components/PartOfferComponents/MessageDrawer";
import PartOfferRateModal from "../components/Modals/PartOfferRateModal";
import PartOfferReportIssueModal from "../components/Modals/PartOfferReportIssueModal";

const PartOfferSinglePage = () => {
    const idParam = useGetIdParam();
    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = useState(null);
    const [rateModalOpen, setRateModalOpen] = useState(false);
    const [reportIssueModalOpen, setReportIssueModalOpen] = useState(false);

    const fetchedPartOffer = useSelector((state) => state.partOffers.partOffer);

    useEffect(() => {
        dispatch(getPartOffer(idParam));
    }, [idParam]);

    useEffect(() => {
        setIsLoaded(true);
    }, [fetchedPartOffer]);

    const [searchParams] = useSearchParams();
    const breadcrumbs = useParseQueryParams(searchParams, "breadcrumbs");

    if (!isLoaded || !fetchedPartOffer) {
        return null;
    }

    const conversationUserIds = [
        fetchedPartOffer.userid,
        fetchedPartOffer.PartRequest.userid,
    ];

    return (
        <BuyerLayout paddingStyle={styles.paddingStyleForBuyerLayout}>
            {rateModalOpen && (
                <PartOfferRateModal
                    open={rateModalOpen}
                    setOpen={setRateModalOpen}
                    partOffer={fetchedPartOffer}
                />
            )}

            {reportIssueModalOpen && (
                <PartOfferReportIssueModal
                    open={reportIssueModalOpen}
                    setOpen={setReportIssueModalOpen}
                    partOffer={fetchedPartOffer}
                />
            )}

            <div style={styles.mainContainer}>
                <div style={styles.leftSection}>
                    <Breadcrumb title={"Ponuda"} breadcrumbs={breadcrumbs} />

                    <div style={styles.sectionSpacing30}>
                        <PartOfferCarInfoDiv fetchedPartOffer={fetchedPartOffer} />
                    </div>

                    <div style={styles.sectionSpacing20}>
                        <PartOfferPartRequestInfoDiv fetchedPartOffer={fetchedPartOffer} />
                    </div>

                    <div style={styles.sectionSpacing30}>
                        <PartOfferBody partOffer={fetchedPartOffer} />
                    </div>

                    <div style={styles.sectionSpacing30}>
                        <PartOfferSellerInfoSection fetchedPartOffer={fetchedPartOffer} />
                    </div>

                    <div style={styles.sectionSpacing50}>
                        <PartOfferFooterSection
                            setRateModalOpen={setRateModalOpen}
                            setReportIssueModalOpen={setReportIssueModalOpen}
                        />
                    </div>
                </div>

                <MessageDrawer
                    partOfferId={idParam}
                    conversationUserIds={conversationUserIds}
                />
            </div>
        </BuyerLayout>
    );
};

export default PartOfferSinglePage;

const styles = {
    paddingStyleForBuyerLayout: {
        paddingLeft: 30,
    },
    mainContainer: {
        display: "flex",
        alignItems: "flex-start",
    },
    leftSection: {
        flex: 1,
        paddingRight: 50,
        paddingTop: 30,
    },
    sectionSpacing20: {
        marginTop: 20,
    },
    sectionSpacing30: {
        marginTop: 30,
    },
    sectionSpacing50: {
        marginTop: 50,
    },
};
